import gql from 'graphql-tag';

export const typeDefs = gql`
  scalar Date
  scalar DateTime
  scalar RichText

  """
  Require that the client pick exactly one of the blah blah.

  Conceptually, this is similar to the [@oneOf GraphQL RFC](https://github.com/graphql/graphql-spec/pull/825), but
  explicitly supports both arguments AND input objects. (The RFC only supports input objects.)

  @example
    # User will be required to provide either id OR slug. (And not both.)
    input SomeArg @pickOne {
      id: ID
      slug: String
    }

  @example
    type Foo {
      # Either "id" or "slug" is required:
      getThing(id: ID, slug: string): Thing @pickOne

      # The properties checked can also be customized. (Only "foo" and "bar" are checked here)
      getOtherThing(foo: string, bar: number, newerThan: DateTime): Thing @pickOne(args: ["foo", "bar"])
    }
  """
  directive @pickOne(
    """
    Customize the list of properties that will be both required and mutually exclusive.
    """
    args: [String]
  ) on INPUT_OBJECT | FIELD_DEFINITION

  type Query {
    """
    Always true.
    """
    _wf: Boolean!
  }
`;
